import "@boot/config/axios"
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import App from '@boot/components/App'
import Context from "@boot/components/Context"
import { Provider } from "react-redux"
import { store } from "@shared/redux/store"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

const queryClient = new QueryClient({ 
    defaultOptions: { 
        queries: {
            cacheTime: Infinity
        }
    } 
})

if (document.getElementById('app')) {
    ReactDOM.render((
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <Router>
                    <Context>
                        <App />
                    </Context>
                </Router>
            </QueryClientProvider>
        </Provider>
    ), document.getElementById('app'));
}